import NotificationApi from '@apis/notification/NotificationApi';
import notificationQueries from '@apis/queries/notificationQueries';
import useLoading from '@hooks/ui/useLoading';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

function useReadAllNotifications() {
    const { t } = useTranslation('notification');
    const queryClient = useQueryClient();
    const toast = useToast();
    const { startLoading, stopLoading } = useLoading();
    const { mutate } = useMutation({
        mutationFn: NotificationApi.readAll,
        onMutate() {
            startLoading();
        },
        onSuccess() {
            queryClient.invalidateQueries({ queryKey: notificationQueries._def });
        },
        onError(e: AxiosError<ErrorResponse>) {
            toast.error(e.response?.data.message || t('toast.error'));
        },
        onSettled() {
            stopLoading();
        },
    });
    return () => { mutate(); };
}

export default useReadAllNotifications;
